import { apolloClient } from "@/plugins/vue-apollo.js";

const createLandlordValidityPlan = (_variables) => {
  // , limit, skip
  let responseFromApi;
  let variables = _variables;
  responseFromApi = apolloClient
    .mutate({
      mutation: require("@/settings/api/mutations/landlord_validity_plan/create_landlord_validity_plan.graphql"),
      variables: variables,
      update: (store, { data }) => {
        const query = {
          query: require("@/settings/api/queries/landlord_validity_plan/get_all_landlord_validity_plan.graphql"),
          variables: {
            input: {
              limit: 10,
              skip: 0
            },
            filter: {
              searchKey: ''
            }
          }
        };
        let allLandlordValidityPlan = store.readQuery(query);
        allLandlordValidityPlan.getAllLandlordValidityPlan.landlordValidityPlans.unshift(data.createLandlordValidityPlan); //push to top
        store.writeQuery({
          ...query,
            data: allLandlordValidityPlan,
        });
      }
    })
    .catch(error => {
      return error;
    });
  return responseFromApi;
};
export { createLandlordValidityPlan };
